const WORDS = ["Scope", "Baseline", "Build", "Test", "Explain", "Real problems", "Honest evidence", "Clear trade-offs"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display px-6 text-[44px] font-bold tracking-tight md:text-[72px] ${i % 2 ? "outline-text" : "text-[#0B1B33]"}`}>{w}</span>
        <span className="h-3 w-3 rotate-45 rounded-[3px] bg-[#14B8A6] md:h-4 md:w-4" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="marquee-wrap overflow-hidden border-b border-slate-200 bg-[#F7FAFC] py-6" aria-hidden="true">
    <div className="marquee-track"><Row /><Row /></div>
  </div>
);
